import { createSustainabilityDetails } from "./createSustainabilityDetails"
import { getSustainabilityDetails } from "./getSustainabilityDetails"
import { editSustainabilityDetails } from "./editSustainabilityDetails"
import { editRiskForTechnicalMonitoring } from "./editRiskForTechnicalMonitoring"

export const SustainabilityService = () => {
  return {
    createSustainabilityDetails,
    getSustainabilityDetails,
    editSustainabilityDetails,
    editRiskForTechnicalMonitoring
  }
}